import React from 'react';
import PropTypes from 'prop-types';
import Chart from 'react-apexcharts';
import { Card, CardBody, CardTitle } from 'reactstrap';

const ChartComponent = ({
  title = undefined,
  options,
  series,
  height,
  chartType = 'bar',
  cardClass = '',
  bodyClass = '',
  chartHeader = null
}) => {
  return (
    <Card className={cardClass}>
      <CardBody className={bodyClass}>
        {chartHeader ? chartHeader : <CardTitle tag="h5">{title}</CardTitle>}
        <Chart options={options} series={series} type={chartType} height={height} />
      </CardBody>
    </Card>
  );
};

ChartComponent.propTypes = {
  title: PropTypes.string.isRequired,
  options: PropTypes.object.isRequired,
  series: PropTypes.array.isRequired,
  height: PropTypes.number.isRequired,
  chartType: PropTypes.string,
  cardClass: PropTypes.string,
  bodyClass: PropTypes.string,
  chartHeader: PropTypes.node
};

export default ChartComponent;
